import { z } from 'zod';
import { Nullable } from 'global';
import { UseFormReturn } from 'react-hook-form';
import { BasePrice, Charge } from 'modules/equipment/types';
import { ListingForm } from 'components/shared/TableListing/types';
import { quoteSchema, formQuoteSchema } from './model/schema';

export type QuoteFormValues = z.infer<typeof formQuoteSchema>;
export type Quote = z.infer<typeof quoteSchema>;

export interface ConfigurationRenderProps {
  isLoading: boolean;
  isFetching: boolean;
  quote: Nullable<Quote>;
  handleCreateOrUpdateQuote: (dto: QuoteFormValues) => Promise<void>;
}

export interface QuoteArrayFieldsProps {
  equipmentId: Nullable<string>;
}

export enum QuoteChargeType {
  Equipment = 'equipment',
  Invoice = 'invoice',
}

export type QuoteEquipmentAttachmentWithCharge = Record<string, any> & { price: BasePrice };

export type QuoteEquipmentWithCharge = Record<string, any> & {
  price: BasePrice;
  attachments: QuoteEquipmentAttachmentWithCharge[];
};

export type QuoteChargeListingEntity = {
  type: QuoteChargeType;
  charge: Nullable<Charge>;
  equipment: Nullable<QuoteEquipmentWithCharge>;
};

export type QuoteChargeListingContext = {
  priceCalc: QuoteChargeListingEntity[];
  form: UseFormReturn<ListingForm<QuoteChargeListingEntity, QuoteChargeListingContext>>;
  onRemoveRow: (index: number) => void;
  isAnyEquipmentActionInProgress: boolean;
  onUnLinkCharge: (index: number) => void;
  onEditEquipment: (id: string, rowIndex: number) => void;
  onRemoveEquipment: (id: string, rowIndex: number) => void;
  onLinkCharge: (attachId: string, currentIndex: number, linkIndex: number) => void;
  onSyncEquipment: (equipment: Nullable<QuoteEquipmentWithCharge>) => Promise<void>;
};

export type NetFinanceAmountListingEntity = {
  hardCost: number;
  fees: number;
  taxes: number;
  softCost: number;
  netFinanceAmount: number;
};

export interface CalculatedTotals {
  fees: number;
  taxes: number;
  price: number;
}

export interface CalculatedTotalsByLevel {
  invoice: CalculatedTotals;
  equipments: CalculatedTotals;
  attachments: CalculatedTotals;
}

export type QuoteAPINameSpase<Response> = { quote: Response };
